import { render, staticRenderFns } from "./NotificationBarItem.vue?vue&type=template&id=14f83c5e&scoped=true&"
import script from "./NotificationBarItem.vue?vue&type=script&lang=js&"
export * from "./NotificationBarItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBarItem.vue?vue&type=style&index=0&id=14f83c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f83c5e",
  null
  
)

export default component.exports